import React, { type ReactElement } from 'react';

import { HelperMessage } from '@atlaskit/form';
import { Box, xcss } from '@atlaskit/primitives';

const helperMessageWrapperStyles = xcss({
	marginBottom: 'space.100',
	display: 'flex',
	justifyContent: 'space-between',
});

const helperMessageDisabledStyles = xcss({
	color: 'color.text.disabled',
});

export const MediaContentHelperMessage = ({
	helperMessage,
	isDisabled,
}: {
	helperMessage: string | ReactElement | undefined;
	isDisabled: boolean | undefined;
}) =>
	helperMessage ? (
		<Box xcss={helperMessageWrapperStyles}>
			<HelperMessage>
				<Box xcss={isDisabled ? helperMessageDisabledStyles : undefined}>{helperMessage}</Box>
			</HelperMessage>
		</Box>
	) : null;
